
import { application } from "./application";

// Auto-imported local controllers
import Controller0 from "./ace_editor_controller.js";
import Controller1 from "./active_link_controller.js";
import Controller2 from "./add_on_kind_controller.js";
import Controller3 from "./autofocus_controller.js";
import Controller4 from "./background_source_controller.js";
import Controller5 from "./calendar_dropdown_controller.js";
import Controller6 from "./checkbox_observer_controller.js";
import Controller7 from "./checkbox_select_all_controller.js";
import Controller8 from "./choices_controller.js";
import Controller9 from "./choose_or_create_controller.js";
import Controller10 from "./click_controller.js";
import Controller11 from "./clipboard_controller.js";
import Controller12 from "./cmd_enter_controller.js";
import Controller13 from "./color_field_controller.js";
import Controller14 from "./color_scheme_controller.js";
import Controller15 from "./coloris_setup_controller.js";
import Controller16 from "./composer_tabs_controller.js";
import Controller17 from "./confirm_controller.js";
import Controller18 from "./contrast_badge_controller.js";
import Controller19 from "./create_event_controller.js";
import Controller20 from "./cropper_controller.js";
import Controller21 from "./current_item_controller.js";
import Controller22 from "./custom_field_form_controller.js";
import Controller23 from "./custom_metadata_validation_controller.js";
import Controller24 from "./custom_text_inspector_controller.js";
import Controller25 from "./customization_draft_banner_controller.js";
import Controller26 from "./customization_draft_controller.js";
import Controller27 from "./default_to_placeholder_controller.js";
import Controller28 from "./dependent_checkboxes_controller.js";
import Controller29 from "./details_dropdown_controller.js";
import Controller30 from "./disable_click_controller.js";
import Controller31 from "./disable_other_element_controller.js";
import Controller32 from "./docs_api_token_controller.js";
import Controller33 from "./docs_code_tabs_controller.js";
import Controller34 from "./docs_nav_controller.js";
import Controller35 from "./docs_search_controller.js";
import Controller36 from "./docs_tooltip_controller.js";
import Controller37 from "./draft_controller.js";
import Controller38 from "./dynamic_turbo_frame_controller.js";
import Controller39 from "./edit_venue_controller.js";
import Controller40 from "./event_preview_controller.js";
import Controller41 from "./example_promotion_codes_controller.js";
import Controller42 from "./field_picker_controller.js";
import Controller43 from "./flash_controller.js";
import Controller44 from "./form_tabs_controller.js";
import Controller45 from "./html_template_form_controller.js";
import Controller46 from "./inactive_overlay_controller.js";
import Controller47 from "./inspector_color_field_controller.js";
import Controller48 from "./inspector_tabs_controller.js";
import Controller49 from "./integration_field_mapping_controller.js";
import Controller50 from "./modal_controller.js";
import Controller51 from "./nested_form_controller.js";
import Controller52 from "./new_data_indicator_controller.js";
import Controller53 from "./offer_interval_controller.js";
import Controller54 from "./open_modal_controller.js";
import Controller55 from "./palette_color_controller.js";
import Controller56 from "./password_strength_controller.js";
import Controller57 from "./placeholder_override_controller.js";
import Controller58 from "./places_autocomplete_controller.js";
import Controller59 from "./poll_refresh_controller.js";
import Controller60 from "./popover_hint_controller.js";
import Controller61 from "./preserve_ids_in_url_controller.js";
import Controller62 from "./preview_refresh_on_submit_controller.js";
import Controller63 from "./price_and_tax_controller.js";
import Controller64 from "./radius_buttons_controller.js";
import Controller65 from "./registrations_chart_form_controller.js";
import Controller66 from "./reload_frame_on_focus_controller.js";
import Controller67 from "./remote_modal_controller.js";
import Controller68 from "./reset_to_default_controller.js";
import Controller69 from "./reveal_controller.js";
import Controller70 from "./reveal_invalid_controller.js";
import Controller71 from "./reveal_switch_controller.js";
import Controller72 from "./scroll_to_selected_controller.js";
import Controller73 from "./search_form_controller.js";
import Controller74 from "./slug_controller.js";
import Controller75 from "./sms_counter_controller.js";
import Controller76 from "./sortable_controller.js";
import Controller77 from "./spotlight_controller.js";
import Controller78 from "./status_controller.js";
import Controller79 from "./sync_inputs_controller.js";
import Controller80 from "./tablist_controller.js";
import Controller81 from "./tax_rate_attachment_controller.js";
import Controller82 from "./templates_nav_link_controller.js";
import Controller83 from "./textarea_autogrow_controller.js";
import Controller84 from "./textarea_suggest_controller.js";
import Controller85 from "./ticket_row_controller.js";
import Controller86 from "./time_controller.js";
import Controller87 from "./time_dropdown_controller.js";
import Controller88 from "./tiptap_controller.js";
import Controller89 from "./tooltip_controller.js";
import Controller90 from "./typeface_warning_controller.js";
import Controller91 from "./uppy_controller.js";
import Controller92 from "./venue_field_controller.js";
import Controller93 from "./web_authn_controller.js";
import Controller94 from "./widget_form_controller.js";

application.register("ace-editor", Controller0);
application.register("active-link", Controller1);
application.register("add-on-kind", Controller2);
application.register("autofocus", Controller3);
application.register("background-source", Controller4);
application.register("calendar-dropdown", Controller5);
application.register("checkbox-observer", Controller6);
application.register("checkbox-select-all", Controller7);
application.register("choices", Controller8);
application.register("choose-or-create", Controller9);
application.register("click", Controller10);
application.register("clipboard", Controller11);
application.register("cmd-enter", Controller12);
application.register("color-field", Controller13);
application.register("color-scheme", Controller14);
application.register("coloris-setup", Controller15);
application.register("composer-tabs", Controller16);
application.register("confirm", Controller17);
application.register("contrast-badge", Controller18);
application.register("create-event", Controller19);
application.register("cropper", Controller20);
application.register("current-item", Controller21);
application.register("custom-field-form", Controller22);
application.register("custom-metadata-validation", Controller23);
application.register("custom-text-inspector", Controller24);
application.register("customization-draft-banner", Controller25);
application.register("customization-draft", Controller26);
application.register("default-to-placeholder", Controller27);
application.register("dependent-checkboxes", Controller28);
application.register("details-dropdown", Controller29);
application.register("disable-click", Controller30);
application.register("disable-other-element", Controller31);
application.register("docs-api-token", Controller32);
application.register("docs-code-tabs", Controller33);
application.register("docs-nav", Controller34);
application.register("docs-search", Controller35);
application.register("docs-tooltip", Controller36);
application.register("draft", Controller37);
application.register("dynamic-turbo-frame", Controller38);
application.register("edit-venue", Controller39);
application.register("event-preview", Controller40);
application.register("example-promotion-codes", Controller41);
application.register("field-picker", Controller42);
application.register("flash", Controller43);
application.register("form-tabs", Controller44);
application.register("html-template-form", Controller45);
application.register("inactive-overlay", Controller46);
application.register("inspector-color-field", Controller47);
application.register("inspector-tabs", Controller48);
application.register("integration-field-mapping", Controller49);
application.register("modal", Controller50);
application.register("nested-form", Controller51);
application.register("new-data-indicator", Controller52);
application.register("offer-interval", Controller53);
application.register("open-modal", Controller54);
application.register("palette-color", Controller55);
application.register("password-strength", Controller56);
application.register("placeholder-override", Controller57);
application.register("places-autocomplete", Controller58);
application.register("poll-refresh", Controller59);
application.register("popover-hint", Controller60);
application.register("preserve-ids-in-url", Controller61);
application.register("preview-refresh-on-submit", Controller62);
application.register("price-and-tax", Controller63);
application.register("radius-buttons", Controller64);
application.register("registrations-chart-form", Controller65);
application.register("reload-frame-on-focus", Controller66);
application.register("remote-modal", Controller67);
application.register("reset-to-default", Controller68);
application.register("reveal", Controller69);
application.register("reveal-invalid", Controller70);
application.register("reveal-switch", Controller71);
application.register("scroll-to-selected", Controller72);
application.register("search-form", Controller73);
application.register("slug", Controller74);
application.register("sms-counter", Controller75);
application.register("sortable", Controller76);
application.register("spotlight", Controller77);
application.register("status", Controller78);
application.register("sync-inputs", Controller79);
application.register("tablist", Controller80);
application.register("tax-rate-attachment", Controller81);
application.register("templates-nav-link", Controller82);
application.register("textarea-autogrow", Controller83);
application.register("textarea-suggest", Controller84);
application.register("ticket-row", Controller85);
application.register("time", Controller86);
application.register("time-dropdown", Controller87);
application.register("tiptap", Controller88);
application.register("tooltip", Controller89);
application.register("typeface-warning", Controller90);
application.register("uppy", Controller91);
application.register("venue-field", Controller92);
application.register("web-authn", Controller93);
application.register("widget-form", Controller94);
